module.exports = __webpack_public_path__ + "387ae249ee068836d6206ef92c1dcc9f.svg";